export class MessengerProxyService {
    static $inject = ['iframeChannel', 'messenger'];

    constructor(private iframeChannel: IFrameChannel, private messenger: Messenger) {
        this.iframeChannel.addBinding('showInfo', (ctx, msg: MessagePayload) => {
            this.messenger.success(msg.message, msg.sticky, msg.messageParams);
        });
        this.iframeChannel.addBinding('showWarning', (ctx, msg: MessagePayload) => {
            this.messenger.warning(msg.message, msg.sticky, msg.messageParams);

        });
        this.iframeChannel.addBinding('showError', (ctx, msg: MessagePayload) => {
            this.messenger.error(msg.message, msg.sticky, msg.messageParams);
        });
    }
}

export interface MessagePayload {
    message: string;
    sticky?: boolean;
    messageParams?: any[];
}


// WEBPACK FOOTER //
// ./src/ui/core/common/services/messenger-proxy.service.ts